import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import "../Styles/TermsAndConditions.css";

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);

  const handleContinue = () => {
    if (accepted) {
      navigate("/login");
    }
  };

  return (
    <div className="terms-container">
      <div className="client-setup-header-main">
        <div className="client-setup-header-left">
          <IoChevronBackOutline
            className="client-setup-back-icon"
            onClick={() =>
              navigate("/client-profile-selection", {
                replace: true,
              })
            }
          />

          <img
            src={require("../assests/images/nav_bar_logo.png")}
            alt="Wedluk Logo"
            className="client-setup-logo"
          />
        </div>

        <div className="client-setup-header-right">
          <span> Terms & conidtions</span>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-center mt-4">
        <div className="terms-card">
          <h2>Terms of Service</h2>

          <p className="terms-subtitle">
            Please review the following terms carefully before continuing with
            account creation.
          </p>

          <div className="terms-content">
            <ol>
              <li>
                By creating an account, you confirm that all information
                provided is accurate.
              </li>
              <li>
                Users are solely responsible for the content shared through
                profiles.
              </li>
              <li>
                WedLuk reserves the right to suspend accounts with false
                information.
              </li>
              <li>
                Users agree to use the platform only for lawful matrimonial
                purposes.
              </li>
              <li>
                WedLuk may provide recommendations but does not guarantee
                outcomes.
              </li>
              <li>
                Membership plans and features may be modified or discontinued.
              </li>
              <li>Users are responsible for maintaining account security.</li>
              <li>User data is processed according to the Privacy Policy.</li>
              <li>
                Users must comply with applicable laws and platform policies.
              </li>
              <li>
                WedLuk is not liable for disputes arising from platform
                connections.
              </li>
            </ol>
          </div>

          <div className="terms-footer">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              I have read and agree to the Terms of Service and Privacy Policy.
            </label>

            <button
              className="accept-btn"
              disabled={!accepted}
              onClick={handleContinue}
            >
              Accept & Continue →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
